import React from "react";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

function Loader(props) {
    function GradientCircularProgress() {
          return (
            <React.Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} />
            </React.Fragment>
          );
        };
    return(<>
        {props.isLoading &&(
            <Box 
            width='100%'
              display='flex'
              justifyContent='center'
              position= 'fixed'
              top='50%'
              zIndex='tooltip' 
              transform='translate(-50%, -50%)'
              sx={{ opacity:'0.4',
               
               }}>
                <GradientCircularProgress />
            </Box>
          )}
    </>);
}
export default Loader;